import { type ReactNode } from 'react'

import { DetailsHeader } from '@/features/admin/components/DetailsHeader'

import styles from './BookkeepingManagerDetails.module.css'

export interface BookkeepingManagerDetailsProps {
  onClose: () => void
  children?: ReactNode
}

export function BookkeepingManagerDetails({
  onClose,
  children,
}: BookkeepingManagerDetailsProps) {
  return (
    <div className={styles.root} data-test="bookkeeping-manager-details">
      <DetailsHeader onClose={onClose} />
      {children}
    </div>
  )
}
